module.exports = __webpack_public_path__ + "static/media/portada2.8e25147c.png";